import loadable from '@loadable/component';

export const LazyReturnPolicy = loadable(
  () =>
    import(
      /* webpackChunkName: "content/catalog/returnpolicy" */
      '.'
    ),
);
